import { render, staticRenderFns } from "./LiveClass.vue?vue&type=template&id=314fa251&scoped=true"
import script from "./LiveClass.vue?vue&type=script&lang=js"
export * from "./LiveClass.vue?vue&type=script&lang=js"
import style0 from "./LiveClass.vue?vue&type=style&index=0&id=314fa251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314fa251",
  null
  
)

export default component.exports